import React, { useState, useEffect } from 'react';
import '../styles/LoginPage.css';
import cost_design_icon from "../assets/svg/cost_design_icon.svg";
import computer_icon from "../assets/svg/computer-icon.png";
import leftmove from "../assets/svg/leftmove_arrow.svg";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useLocation } from 'react-router-dom';
import { FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import axiosInstance from "../axiosInstance";
import lentera from "../assets/svg/lentera-icon.svg";

const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const token = location.state?.token;

    useEffect(() => {
        if (!token) {
            toast.error("Invalid password reset token");
            navigate("/forgetpassword");
        }
    }, [token, navigate]);

    const handleSubmit = async () => {
        let validationErrors = {};
        if (!password) validationErrors.new_password = "Password is required";
        if (!confirmPassword) validationErrors.confirm_password = "Confirm password is required";
        if (password && confirmPassword && password !== confirmPassword)
            validationErrors.confirm_password = "New Password and Confirm Password not matched";

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setLoading(true);
        try {
            const response = await axiosInstance.post("/resetpassword", {
                token,
                new_password: password,
                confirm_password: confirmPassword
            });

            if (response.data.success) {
                toast.success(response.data.message || "Password updated successfully");
                setTimeout(() => navigate("/login"), 1500);
            } else {
                if (response.data.error) {
                    const backendErrors = response.data.error;
                    setErrors(backendErrors);
                } else {
                    toast.error(response.data.message || "Something went wrong");
                }
            }
        } catch (err) {
            console.error(err);
            if (err.response?.data?.error) {
                const backendErrors = err.response.data.error;
                setErrors(backendErrors);
            } else {
                toast.error("Failed to reset password");
            }
        } finally {
            setLoading(false);
        }

    };

    return (
        <>
            <div className="login-page">
                <div className="left-panel">
                    <div className="logo">
                        <img src={cost_design_icon} alt='' className='cost-design-icon' />
                        <span>WBS</span>
                    </div>
                    <h2>PRECISION WAREHOUSE BILLING MADE <br />SIMPLE</h2>
                    <div className="laptop-container">
                        <img src={computer_icon} alt="Laptop Hand" className="laptop-image" />
                        <div className="laptop-shadow"></div>
                    </div>
                </div>

                <div className="right-panel">
                    <img
                        src={leftmove}
                        onClick={() => navigate(-1)}
                        style={{ width: '30px', height: '30px', marginBottom: '8px', cursor: 'pointer' }}
                        alt=""
                    />
                    <h2>Reset Your Password</h2>
                    <p>Set a memorable password for easy log-in</p>

                    <form className="login-form">
                        <label>New Password <span style={{ color: 'red',marginBottom:'10px' }}>*</span></label>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #E0E0E0",
                            borderRadius: "12px",
                            padding: "10px",
                        }}>
                            <FiLock style={{ marginRight: "10px", color: "#cbd5e1" }} />
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="New Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                style={{ border: "none", outline: "none", flex: 1, background: "transparent", height: '20px',margin:'0px' }}
                            />
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{ cursor: "pointer", color: "#475569", fontWeight: "500", fontSize: "13px" }}
                            >
                                {showPassword ? <FiEyeOff /> : <FiEye />}
                            </span>
                        </div>
                        {errors.new_password && (
                            <div className="error-message" style={{ color: 'red', fontSize: '12px', marginLeft: "5px", marginTop: '5px' }}>
                                {Array.isArray(errors.new_password)
                                    ? errors.new_password.map((err, i) => <div key={i}>{err}</div>)
                                    : errors.new_password}
                            </div>
                        )}


                        {/* Confirm Password */}
                        <label style={{ marginTop: '10px' }}>Confirm Password <span style={{ color: 'red' }}>*</span></label>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #E0E0E0",
                            borderRadius: "12px",
                            padding: "10px",
                        }}>
                            <FiLock style={{ marginRight: "10px", color: "#cbd5e1" }} />
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Confirm Password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                style={{ border: "none", outline: "none", flex: 1, background: "transparent", height: '20px',margin:'0px'  }}
                            />
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{ cursor: "pointer", color: "#475569", fontWeight: "500", fontSize: "13px" }}
                            >
                                {showPassword ? <FiEyeOff /> : <FiEye />}
                            </span>
                        </div>
                        {errors.confirm_password && <div className="error-message" style={{ color: 'red', fontSize: '12px', marginLeft: "5px", marginTop: '5px' }}>{errors.confirm_password}</div>}

                        <button
                            type="button"
                            className="sign-in-button"
                            onClick={handleSubmit}
                            disabled={loading}
                            style={{ marginTop: '15px' }}
                        >
                            {loading ? "Updating..." : "Reset Password"}
                        </button>
                    </form>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "16px",
                        }}
                    >
                        <span>{new Date().getFullYear()} © Powered by</span>
                        <a href="https://lenteratech.com/" target="_blank" rel="noreferrer">
                            <img
                                src={lentera}
                                alt="Lentera"
                                style={{
                                    height: "14px",
                                    display: "block",
                                }}
                            />
                        </a>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </>
    );
};

export default ResetPassword;
